<template>
  <v-snackbar
    v-model="paymentNotification"
    bottom
    left
    :timeout="-1"
    height="80"
    color="info"
  >
    <v-row no-gutters>
      <v-col cols="3">
        <v-progress-circular
          :rotate="360"
          :size="60"
          :width="5"
          :value="progressValue"
          color="white"
        >
          <span>{{ paymentsSynced.length }} of {{ payments.length }}</span>
        </v-progress-circular>
      </v-col>
      <v-col cols="9" class="justify-center text-start" align-self="center">
        <h3>Sync payment</h3>
        <span>{{ paymentLabel }}</span>
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>

import { EventBus } from '../mixins';

export default {
  props: {
    payments: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      paymentNotification: false,
      paymentLabel: null
    };
  },
  computed: {
    progressValue () {
      return Math.round((this.paymentsSynced.length * 100) / this.payments.length);
    },
    paymentsSynced () {
      return this.payments.filter(p => p.status !== 'loading');
    }
  },
  mounted () {
    EventBus.$on('change-payment-notification-status', this.showPaymentNotification);
    EventBus.$on('change-payment-label', this.changePaymentLabel);
  },
  methods: {
    showPaymentNotification () {
      this.paymentNotification = !this.paymentNotification;
    },
    changePaymentLabel (label) {
      this.paymentLabel = label;
    }
  }
};

</script>
